import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { getAllCategory } from '../../../services/api/Category';
import type { FormData } from '../../../types';

interface ProductCategoryProps {
	formData: FormData;
	setFormData: React.Dispatch<React.SetStateAction<FormData>>;
	disabled?: boolean;
}

const ProductCategory: React.FC<ProductCategoryProps> = ({ formData, setFormData, disabled }) => {
	const [categories, setCategories] = useState<{ categoryName: { name: string } }[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const fetchCategories = async () => {
			try {
				setLoading(true);
				const response = await getAllCategory();
				setCategories(Array.isArray(response?.data) ? response.data : []);
			} catch (error) {
				console.error('Failed to fetch categories:', error);
				setCategories([]);
			} finally {
				setLoading(false);
			}
		};
		fetchCategories();
	}, []);

	const handleChange = (e: any) => {
		setFormData((prev) => ({ ...prev, category: e.target.value }));
	};

	// Find if the current category exists in the fetched categories
	const currentCategoryExists = categories.some(
		(cat) => cat.categoryName?.name === formData.category
	);

	return (
		<Grid size={{ xs: 12 }}>
			<FormControl fullWidth margin="normal" size="small" sx={{ margin: '0px' }}>
				<InputLabel id="category">Category</InputLabel>
				<Select
					label="Category"
					name="category"
					id="category"
					value={formData.category}
					onChange={handleChange}
					required
					labelId="category"
					disabled={loading || disabled}
					sx={{ fontSize: { xs: 14, sm: 16, md: 18 } }}
				>
					<MenuItem value="">Select Category</MenuItem>
					{/* First show the current category if it exists but isn't in the fetched list */}
					{!currentCategoryExists && formData.category && (
						<MenuItem value={formData.category} selected>
							{formData.category}
						</MenuItem>
					)}
					{/* Then show all the categories from the API */}
					{categories.map((category, index) => (
						<MenuItem key={index} value={category.categoryName?.name || ''}>
							{category.categoryName?.name || 'Unnamed Category'}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Grid>
	);
};

export default ProductCategory;
